import React from 'react';
import { AlertCircleIcon, TrendingDownIcon, ClockIcon, UsersIcon, DollarSignIcon } from 'lucide-react';
export function ProblemSection() {
  const painPoints = [{
    icon: TrendingDownIcon,
    title: 'The Ghost Town',
    description: 'You hire a rep, and they disappear 3 days later.'
  }, {
    icon: AlertCircleIcon,
    title: 'Feast or Famine',
    description: 'One month you have 8 good hires, the next month you have zero.'
  }, {
    icon: ClockIcon,
    title: 'Wasted Leadership Time',
    description: 'You spend hours interviewing people who should never have been in the room.'
  }, {
    icon: UsersIcon,
    title: 'Failure to Launch',
    description: 'Rookies quit before they knock their first 100 doors.'
  }];
  return <section className="section-padding bg-white" data-id="element-825">
      <div className="container-custom" data-id="element-826">
        <div className="max-w-3xl mx-auto text-center mb-12 md:mb-16" data-id="element-827">
          <h2 className="mb-4 md:mb-6" data-id="element-828">Why "Post and Pray" Is Failing You</h2>
          <p className="text-base md:text-lg text-gray-600 leading-relaxed" data-id="element-829">
            You aren't bad at recruiting. You just don't have a system. You are
            trying to scale a sales team{' '}
            <span className="font-bold text-navy" data-id="element-830">
              on luck, and it's costing you money
            </span>
            .
          </p>
        </div>

        <div className="max-w-4xl mx-auto mb-12 md:mb-16" data-id="element-831">
          <div className="bg-gradient-to-br from-amber/10 to-amber/5 rounded p-6 md:p-8 lg:p-12 border-2 border-amber/30" data-id="element-832">
            <div className="flex items-center justify-center mb-4 md:mb-6" data-id="element-833">
              <div className="w-10 h-10 md:w-12 md:h-12 lg:w-14 lg:h-14 bg-amber rounded flex items-center justify-center" data-id="element-834">
                <DollarSignIcon className="h-5 w-5 md:h-6 md:w-6 lg:h-7 lg:w-7 text-navy" data-id="element-835" />
              </div>
            </div>
            <h3 className="text-center mb-6 md:mb-8 text-navy text-lg md:text-xl lg:text-2xl" data-id="element-836">
              The Hidden Cost
            </h3>
            <div className="grid grid-cols-2 gap-3 md:gap-4 lg:gap-6" data-id="element-837">
              <div className="bg-white rounded p-4 md:p-5 lg:p-6 border border-amber/20" data-id="element-838">
                <div className="text-xl md:text-2xl font-bold text-amber mb-1 md:mb-2" data-id="element-839">
                  Lost Revenue
                </div>
                <p className="text-gray-700 text-xs md:text-sm" data-id="element-840">
                  Per empty seat (Opportunity Cost)
                </p>
              </div>
              <div className="bg-white rounded p-4 md:p-5 lg:p-6 border border-amber/20" data-id="element-841">
                <div className="text-xl md:text-2xl font-bold text-amber mb-1 md:mb-2" data-id="element-842">
                  15+ Hours/Week
                </div>
                <p className="text-gray-700 text-xs md:text-sm" data-id="element-843">
                  Of leadership time burned on bad interviews
                </p>
              </div>
              <div className="bg-white rounded p-4 md:p-5 lg:p-6 border border-amber/20" data-id="element-844">
                <div className="text-xl md:text-2xl font-bold text-amber mb-1 md:mb-2" data-id="element-845">
                  6–12 Months
                </div>
                <p className="text-gray-700 text-xs md:text-sm" data-id="element-846">
                  Of growth lost because you can't find people
                </p>
              </div>
              <div className="bg-white rounded p-4 md:p-5 lg:p-6 border border-amber/20" data-id="element-847">
                <div className="text-xl md:text-2xl font-bold text-amber mb-1 md:mb-2" data-id="element-848">
                  Constant Stress
                </div>
                <p className="text-gray-700 text-xs md:text-sm" data-id="element-849">
                  Always wondering where the next hire is coming from
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-4 md:gap-6 lg:gap-8 max-w-5xl mx-auto" data-id="element-850">
          {painPoints.map((pain, index) => {
          const Icon = pain.icon;
          return <div key={index} className="bg-gray-50 rounded p-5 md:p-6 lg:p-8 border border-gray-200" data-id="element-851">
                <div className="flex items-start gap-3 md:gap-4 mb-3" data-id="element-852">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-amber/10 rounded flex items-center justify-center flex-shrink-0" data-id="element-853">
                    <Icon className="h-5 w-5 md:h-6 md:w-6 text-amber" data-id="element-854" />
                  </div>
                  <h4 className="text-base md:text-lg flex-1 leading-tight pt-1 md:pt-2" data-id="element-855">
                    {pain.title}
                  </h4>
                </div>
                <p className="text-gray-600 text-sm md:text-base" data-id="element-856">
                  {pain.description}
                </p>
              </div>;
        })}
        </div>

        <div className="mt-12 md:mt-16 text-center" data-id="element-857">
          <div className="inline-block bg-navy/5 border-l-4 border-amber px-6 md:px-8 py-4 md:py-6 rounded max-w-3xl" data-id="element-858">
            <p className="text-base md:text-lg text-gray-700 italic" data-id="element-859">
              "You don't need to work harder at recruiting. You need a system
              that does the heavy lifting for you."
            </p>
          </div>
        </div>
      </div>
    </section>;
}